import { Component } from '@angular/core';
import { SimpleLoginFormComponent } from '@tango/app/login/simple-login-form';

/**
 * Форма логина, которая проверяет валидность полей только после Submit.
 */
@Component({
  selector: 'bank-simple-login-form',
  templateUrl: './simple-login-form.component.html'
})
export class BankSimpleLoginFormComponent extends SimpleLoginFormComponent {}
